import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

import { DrawerOptions } from '#/components/Drawer/types'

export const DrawerWrapper = styled(Box)(({ width = 300 }: { width: DrawerOptions['width'] }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  width: `min(${typeof width === 'number' ? `${width}px` : width}, 100vw)`,
}))

export const DrawerHeader = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '20px 30px',
  width: '100%',
}))

export const DrawerFooter = styled(Box)(({ theme }) => ({
  '&:empty': { display: 'none' },
  'background': theme.palette.common.white,
  'boxShadow': theme.shadows[5],
  'marginTop': 16,
  'padding': '12px 24px',
}))

export const DrawerContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: '0 24px 8px',
})
